import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
html{
  height: 100%;
  width: 100%;
}

  body {
    background-size: cover;
    background-color: #f0f5ff;
    box-sizing: border-box;
    color: #555;
    font-family: "Ubuntu", "Roboto", sans-serif;
    font-weight: 400;
    height: 100%;
    line-height: 1.65;
    overflow-x: visible;
    width: 100%;
    scroll-behavior: smooth;

  }
  button:focus {
    outline: 0;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  a {
    text-decoration: none;
  }
  
  *,
  *::after,
  *::before {
    box-sizing: inherit;
    padding: 0;
    margin: 0;

  }
  button, input[type="submit"], input[type="reset"] {
	background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
}

*:focus {
    outline: none;
}
  
  
  `;

export default GlobalStyles;
